import { Charts } from './Charts';
import ServicesChartsDataProvider from './contexts/ServicesChartsDataContext';

const ProceduresWrapper = () => {
    return (
        <ServicesChartsDataProvider>
            <Charts />
        </ServicesChartsDataProvider>
    );
};

export default ProceduresWrapper;
